import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Typography,
    styled,
    Tooltip,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@mui/material";
import React, { useState } from "react";
import { CardTitleHead } from "components/typography/text";
import { ApiUrls, HostName, urlChatPage } from "services/utils/globalVariables";
import { dispatchHandler, useContextDispatch, useContextState } from "services/context/MainContext";
import { toast } from "react-toastify";
import useFetch from "services/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { actionTypes } from "services/context/reducer";

const AwardsCard = styled(Card)(
    ({ theme }) => `
        max-width: calc(50% - 8px);
        flex: 0 0 calc(50% - 8px);
        box-shadow: ${theme.shadows[3]};
        borderRadius: 10px;
        margin-top: ${theme.spacing(2)};
        background: white;
    `,
);

const AwardsCardImage = styled(CardMedia)(
    ({}) => `
        height: 130px;
        background-size: contain;
    `,
);

export default function AwardCard({ data }) {
    const [{}, doPrizeFetch] = useFetch(ApiUrls.RequestPrize, "post", true);
    const [{}, doCustomerFetch] = useFetch(ApiUrls.GetCustomerInfo, "get");

    const [load, setLoad] = useState(false);
    const [open, setOpen] = useState(false);

    const navigate = useNavigate();

    const { userInfo } = useContextState();
    const { GET_USERINFO } = actionTypes;
    const dispatch = useContextDispatch();

    const handleGetPrize = () => {
        setLoad(true);
        setOpen(false);
        if (data.Point > userInfo.Point) {
            setLoad(false);
            toast.warning("امتیاز شما برای دریافت این جایزه کافی نمی باشد.");
        } else {
            doPrizeFetch({ prizeId: data.Id }, handleCheckState);
        }
    };

    const handleCheckState = (res) => {
        setLoad(false);
        if (res.Data == "false") {
            toast.error("مشکلی پیش آمد");
        } else {
            toast.success("درخواست شما با موفقیت ثبت شد");
            doCustomerFetch(null, handleRefreshInfo);
            setTimeout(() => navigate(`${urlChatPage}/${res.Data}`), 2000);
        }
    };

    const handleRefreshInfo = (res) => {
        dispatchHandler(dispatch, GET_USERINFO, { userInfo: res.Data });
    };

    return (
        <>
            <AwardsCard>
                <Box sx={{ p: 2 }}>
                    <AwardsCardImage image={`${HostName}/${data.ImageURL}`} title={data.Name} />
                </Box>
                <CardContent>
                    <Tooltip title={data.Name} arrow>
                        <CardTitleHead
                            sx={{
                                mb: 2,
                                height: "40px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: "2",
                                WebkitBoxOrient: "vertical",
                            }}
                        >
                            {data.Name}
                        </CardTitleHead>
                    </Tooltip>
                    <Typography textAlign="center" variant="body2" color="text.secondary">
                        <b style={{ marginLeft: "0.25rem" }}>{data.Point}</b> امتیاز
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button
                        disabled={load}
                        endIcon={load && <CircularProgress size="small" />}
                        onClick={() => setOpen(true)}
                        sx={{ width: "100%", borderRadius: "0px 0px 6px 6px", color: "rgba(0, 0, 0, 0.26)" }}
                        variant="contained"
                    >
                        دریافت جایزه
                    </Button>
                </CardActions>
            </AwardsCard>
            <ConfirmModal getPrize={handleGetPrize} open={open} setOpen={setOpen} />
        </>
    );
}

const ConfirmModal = ({ getPrize, open, setOpen }) => {
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle sx={{ fontWeight: "bold", textAlign: "left" }}>تایید درخواست</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ textAlign: "left" }}>آیا از ثبت درخواست خود اطمینان دارید ؟</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "flex-start", p: 2 }}>
                <Button
                    onClick={getPrize}
                    // onClick={() => toast.error("باتوجه به شرایط موجودامکان دریافت جایزه وجود ندارد")}
                    color="primary"
                    variant="contained"
                >
                    تایید
                </Button>
                <Button onClick={() => setOpen(false)} color="error" variant="text" sx={{ mr: 2 }}>
                    انصراف
                </Button>
            </DialogActions>
        </Dialog>
    );
};
